import React from 'react';
import { Link } from 'react-router-dom';

import { SOCIAL_POST_APP_ID } from '@frontend/app/constants/applicationIds';
import type { CreatorDiscoveryInstagramAccount } from '@frontend/app/hooks';
import { Button } from '@frontend/shadcn/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@frontend/shadcn/components/ui/dropdown-menu';
import { ChevronDownIcon } from '@radix-ui/react-icons';

interface InstagramAccountDropdownProps {
  instagramAccounts: CreatorDiscoveryInstagramAccount[];
  selectedInstagramAccount: CreatorDiscoveryInstagramAccount | undefined;
  setSelectedInstagramAccount: (account: CreatorDiscoveryInstagramAccount) => void;
  isLoading: boolean;
}

export const InstagramAccountDropdown: React.FC<InstagramAccountDropdownProps> = ({
  instagramAccounts,
  selectedInstagramAccount,
  setSelectedInstagramAccount,
  isLoading,
}) => {
  // If no Instagram accounts and not loading, show the connect button
  if (!isLoading && instagramAccounts.length === 0) {
    return (
      <Button variant="outlineHeader" asChild>
        <Link to={`/settings/${SOCIAL_POST_APP_ID}`}>Connect Instagram Account</Link>
      </Button>
    );
  }

  // Otherwise show the dropdown
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outlineHeader" disabled={isLoading}>
          <div className="flex items-center justify-between w-full">
            @{selectedInstagramAccount?.username || 'Select Instagram'}
            <ChevronDownIcon className="ml-2 h-4 w-4 flex-shrink-0" />
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {instagramAccounts.map((account) => (
          <DropdownMenuItem
            key={account.igUserId}
            onSelect={() => setSelectedInstagramAccount(account)}
            className="cursor-pointer"
          >
            @{account.username}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
